<div class="padding">
    <div>
      <div class="header">{{ 'addEdit_dataset' | translate }}</div>
    </div>
    <div>
      <mat-icon class="close-icon" (click)="close()">close</mat-icon>
    </div>
  
    <form (ngSubmit)="create()" #form="ngForm" novalidate>
      <div class="flexColumn">
  
        <mat-form-field appearance="fill">
          <mat-label>{{ 'dataset_name' | translate }}</mat-label>
          <input type="text" name="name" matInput #name="ngModel" placeholder="Name" required
            [(ngModel)]="dataset.name" pattern="^[\sa-zA-Z0-9\(\)_\-]+$" minlength="5" maxlength="20">
          <mat-hint>Minimum characters 20, {{dataset.name == null ? 0 : dataset.name?.length}}/20
            Characters</mat-hint>
          <mat-error *ngIf="name.hasError('required')">{{ 'datasetName_required' | translate }}</mat-error>
          <mat-error *ngIf="name.hasError('minlength')">{{ 'datasetName_minLength' | translate }}</mat-error>
          <mat-error *ngIf="name.hasError('pattern')">{{ 'characters_allowed' | translate }}</mat-error>
        </mat-form-field>
  
        <mat-form-field appearance="fill">
          <mat-label>{{ 'dataset_description' | translate }}</mat-label>
          <input type="text" name="description" matInput #description="ngModel" placeholder="Description"
            [(ngModel)]="dataset.description" pattern="^[\sa-zA-Z0-9\(\)_\-]+$" maxlength="36">
          <mat-hint>{{dataset.description == null ? 0 : dataset.description?.length}}/36 Characters</mat-hint>
          <mat-error *ngIf="description.hasError('pattern')">{{ 'charactersGuid_allowed' | translate }}</mat-error>
        </mat-form-field>
  
        <mat-form-field appearance="fill">
          <mat-label>{{ 'dataset_backfillDays' | translate }}</mat-label>
          <input type="number" min="0" [max]="999" matInput [(ngModel)]="dataset.backfill_days"
            name="backfill_days" #backfill_days="ngModel" required pattern="^[0-9]+$">
          <mat-hint>{{dataset.backfill_days == null ? 0 : dataset.backfill_days}}/999</mat-hint>
          <mat-error *ngIf="backfill_days.hasError('required')">{{ 'positiveInteger_error' | translate }}</mat-error>
          <mat-error *ngIf="backfill_days.hasError('pattern')">{{ 'positiveInteger_error' | translate }}</mat-error>
          <mat-error *ngIf="backfill_days.hasError('min')">{{ 'positiveInteger_error' | translate }}</mat-error>
          <mat-error *ngIf="backfill_days.hasError('max')">{{ 'positiveInteger_error' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>{{ 'dataset_file' | translate }}</mat-label>
          <input type="text" name="file" matInput #file="ngModel" placeholder="File"
            [(ngModel)]="dataset.file" disabled="true" required>
          <mat-error *ngIf="file.hasError('required')">{{ 'datasetFile_required' | translate }}</mat-error>
        </mat-form-field>

        <input #fileSelecter type="file" (change)="selectFile($event)"/>
  
        <div class="saveRow">
          <a type="button" mat-raised-button (click)="cancel()">{{ 'cancel' | translate }}</a>
          <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid">{{ 'save' | translate }}</button>
        </div>
  
      </div>
    </form>
  
  </div>